/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateRoleDto
 */
export interface CreateUpdateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRoleDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRoleDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateRoleDto
     */
    permissions: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateRoleDto
     */
    withBudget: boolean;
}

/**
 * Check if a given object implements the CreateUpdateRoleDto interface.
 */
export function instanceOfCreateUpdateRoleDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "permissions" in value;
    isInstance = isInstance && "withBudget" in value;

    return isInstance;
}

export function CreateUpdateRoleDtoFromJSON(json: any): CreateUpdateRoleDto {
    return CreateUpdateRoleDtoFromJSONTyped(json, false);
}

export function CreateUpdateRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateRoleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'permissions': json['permissions'],
        'withBudget': json['withBudget'],
    };
}

export function CreateUpdateRoleDtoToJSON(value?: CreateUpdateRoleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'permissions': value.permissions,
        'withBudget': value.withBudget,
    };
}

